import { KeyValue } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { FilterService } from 'src/modules/base/services/filter.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { FilterHelperService } from 'src/modules/base/services/filter-helper.service';

@Component({
    selector: 'app-bed-dashboard',
    templateUrl: './bed-dashboard.component.html',
    styleUrls: ['./bed-dashboard.component.scss'],
    standalone: false
})
export class BedDashboardComponent implements OnInit {
  fields: any; filterKey: any;
  resource: any;filterParam:any="";
  id: any; @Output() bindGrid: EventEmitter<any> = new EventEmitter();
  @ViewChild('kxFilter', { static: false }) kxFilter: any;
  filterFormGroup: any;
  filterFormMapping: any;
  final_data: any;
  count: any;
  total_vacant: any;
  total_occupancy: number;
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }
  filterAr: any[] = [];
  filterConfig: any = {};
  preferenceData: any = {};
  config: any = {
    "submitButton": true,
    "filterForm": true,
    "clearOnSave": false,
    "delegateSave": true,
    "setSearchPopup": false,
    "cancelRoute": '',
    "complex_search": '',
    "save_filter": false
  }

  constructor(
    private baseService: BaseService,
    private aroute: ActivatedRoute,
    private spinner: LoaderService,
    private alert: AlertsService,
    private filterService: FilterService,
    public preferenceService: PreferenceService,
    public dialogService: DialogService,
    private filterHelperService: FilterHelperService
  ) { }

  ngOnInit() {
    this.getResourceDetails()
  }

  getResourceDetails() {
    this.baseService.getResourceDef(this.aroute.snapshot.data.resource, (resourcedef: any) => {
      if (resourcedef) {
        if (this.aroute.snapshot.queryParams.hasOwnProperty("tab_0"))
          this.getResourceInfo(resourcedef.layout.find(x => x.id == this.aroute.snapshot.queryParams.tab_0).component.resource, resourcedef.layout.find(x => x.id == this.aroute.snapshot.queryParams.tab_0).component.patient_type)
        else
          this.getResourceInfo(resourcedef.layout.find(x => x.id == resourcedef.default_layout_id).component.resource, resourcedef.layout.find(x => x.id == resourcedef.default_layout_id).component.patient_type)
      }
    })
  }

  getResourceInfo(resource: any, id: any) {
    this.baseService.getResourceDef(resource, (resouceDef) => {
      if (resouceDef) {
        this.baseService.setTitle(resouceDef.title);
        this.resource = resouceDef;
        this.id = id;
        this.config['save_filter'] = this.resource.config?.save_filter || false;
        this.config['saveKey'] = resource + '_list_config';
        this.filterAr = [];
        this.filterConfig = {};
        this.preferenceData = {};
        this.getSavedFilter();
        // this.callAPI();
        this.spinner.showSpinner();
      }
    })
  }
  getWidth(occupancy) {
    return { "width": `${occupancy}%` };
  }

  resetFilter(event: any) {
    // this.filterParam = "";
    // this.callAPI();
    this.displayFilter();
    this.bindGrid.emit();
    this.spinner.showSpinner();
  }

  doSearch(event: any) {
    this.bindGrid.emit(event);
    this.filterParam = event;
    this.filterParam = this.filterService.removeDuplicateKeysFromString({ "filter": this.filterParam });
    this.callAPI();
    this.displayFilter();
    this.spinner.showSpinner();
  }

  getDataFn(event: any) {
    if (event && event.type == "form" && event.obj && event.obj.form != undefined) {
      this.filterFormGroup = event.obj.form;
    } else if (event && event.type == "mapping" && event.obj && event.obj.form != undefined) {
      this.filterFormMapping = event.obj.form;
    } else if (event && event.type == "default_filter_val" && event.obj && event.obj.form) {
      this.bindGrid.emit(event.obj.form);
      this.filterParam = event.obj.form;
      this.filterParam = this.filterService.removeDuplicateKeysFromString({ "filter": Object.entries(this.filterParam).map(([a, b]) => { if (b) { return `${a}: ${b}` } }).filter(x => x != undefined).join(",").replace(" ", "") });
      this.callAPI();
      this.spinner.showSpinner();
    } else if (event && event.type == 'filter_save') {
      this.saveFilterData(event.obj);
    }
  }

  public onFilterClick(event) {
    this.spinner.showSpinner();
    this.callAPI(event);
  }

  displayFilter(){
    if (this.resource.filter.hasOwnProperty('default_open'))
    this.resource.filter.default_open = !this.resource.filter.default_open
  }

  callAPI(search?) {
    this.filterKey = search;
    var args = {
      "args": this.resource.datasource.args.replace("!!!getterKey!!!", this.id)
    }
    if (this.filterKey != '' && this.filterKey != undefined) {
      args['search'] = this.filterKey.value;
      args["search_columns"] = this.filterKey.key;
    }

    if (this.filterParam)
      args['filter'] = this.filterParam


    this.baseService.getData(args, "", this.resource.datasource.resource, this.resource.datasource.application, this.resource.datasource.query_id).subscribe((data: any) => {
      if (data.errCode == -1) {
        this.alert.error(data.message);
      } else {
        if (data.resource.length != 0) {
          let temp1 = data.resource;
          this.count = data.resource.length;
          this.total_vacant = data.resource.filter(x => x.stage_action == "occupied").length;
          this.total_occupancy = Math.round((data.resource.filter(x => x.stage_action == "occupied").length / data.count) * 100)
          this._callForColors(temp1);
        } else {
          this.alert.error("No bed Found !!!");
        }
      }
      this.spinner.hideSpinner()
    })
  }

  // ─── Saved Filter Methods (delegated to FilterHelperService) ────────────────

  getTableConfig(callback: any, force?: boolean) { this.filterHelperService.getTableConfig(this, callback, force); }
  getSavedFilter(callback?: Function) { this.filterHelperService.getSavedFilter(this, callback); }
  checkFilterCondition(filter: any): boolean { return this.filterHelperService.checkFilterCondition(filter); }
  applyFilter(filter: any) { this.filterHelperService.applyFilter(this, filter); }
  saveFilterData(obj: any) { this.filterHelperService.saveFilterData(this, obj); }
  saveTableConfigData(data: any, callback: any = false, userScope?: boolean, del?: string) { this.filterHelperService.saveTableConfigData(this, data, callback, userScope, del); }
  manageFilter() { this.filterHelperService.manageFilter(this); }

  // ─────────────────────────────────────────────────────────────────────────────

  _callForColors(temp1) {
    this.spinner.showSpinner()
    var _args = { args: "" }
    this.baseService.getData(_args, "", this.resource.detail_datasource.resource, this.resource.detail_datasource.application, this.resource.detail_datasource.query_id).subscribe((_result: any) => {
      if (_result.errCode == 0) {
        if (_result.resource.length != 0) {
          this.final_data = [...new Set(temp1.map(x => x.ward_name))].map(x => { return { ward_name: x, total_count: temp1.filter(a => a.ward_name == x).length, ward_status: Object.keys(this.resource.css).map(key => { return { status_name: key, status_value: temp1.filter(a => a.ward_name == x).filter(b => b.stage_action == key).length, image: this.resource.css[key] } }), occupancy: Math.round((temp1.filter(a => a.ward_name == x).filter(b => b.stage_action == "occupied").length / temp1.filter(a => a.ward_name == x).length) * 100), background: (_result.resource.find(e=>e.name == x)!=undefined && _result.resource.find(e=>e.name == x).ward_color!=undefined)?_result.resource.find(e=>e.name == x).ward_color+"4a":"#fafafa"} }).sort((a: any, b: any) => !a.ward_name?0:a.ward_name.localeCompare(b.ward_name))
        } else {
          this.final_data = [...new Set(temp1.map(x => x.ward_name))].map(x => { return { ward_name: x, total_count: temp1.filter(a => a.ward_name == x).length, ward_status: Object.keys(this.resource.css).map(key => { return { status_name: key, status_value: temp1.filter(a => a.ward_name == x).filter(b => b.stage_action == key).length, image: this.resource.css[key] } }), occupancy: Math.round((temp1.filter(a => a.ward_name == x).filter(b => b.stage_action == "occupied").length / temp1.filter(a => a.ward_name == x).length) * 100) ,background: '#fafafa'} }).sort((a: any, b: any) => !a.ward_name?0:a.ward_name.localeCompare(b.ward_name))
        }
        console.log("this.bed dashboard ",this.final_data);
      } else {
        this.alert.error(_result.message)
      }
      this.spinner.hideSpinner()
    })
  }

}
